import React from "react";
import { VakQuestion } from "../../typings/vak";
import Modal from "../UI/Modal";
import Button from "../UI/Button";
import { Progress } from "../UI/Progress";
import { getAnswerOptionLabels } from "../../utils/vak";

interface VakAnswersSummaryProps {
  questions: VakQuestion[];
  answers: { [key: number]: number };
  show: boolean;
  onClose: () => void;
}

const RiasecAnswersSummary: React.FC<VakAnswersSummaryProps> = ({
  questions,
  answers,
  onClose,
  show,
}) => {
  const answeredCount = Object.keys(answers).length;
  const totalQuestions = questions.length;
  const progress =
    totalQuestions > 0 ? (answeredCount / totalQuestions) * 100 : 0;

  return (
    <Modal show={show} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Ringkasan Jawaban</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <strong>Progress:</strong> <br /> <strong>{answeredCount}</strong>{" "}
          dari <strong>{totalQuestions}</strong> pertanyaan dijawab
          <Progress value={progress} className="flex-1 h-2 mt-2 bg-muted" />
        </div>

        <div className="max-h-[400px] overflow-y-auto">
          {questions.map((question, index) => (
            <div
              key={question.id}
              className="answer-summary-item mb-2 p-2 border rounded"
            >
              <div className="flex justify-between items-center gap-2">
                <span>
                  <strong>Q{index + 1}:</strong> {question.question}
                </span>
                <span>
                  {answers.hasOwnProperty(question.id) ? (
                    <span
                      className={`font-bold ${
                        answers[question.id]
                          ? "text-primary"
                          : "text-foreground"
                      }`}
                    >
                      {getAnswerOptionLabels(answers[question.id])?.label || '-'}
                    </span>
                  ) : (
                    <span className="inline-block px-2 py-1 text-xs font-medium rounded bg-yellow-500 text-black">
                      -
                    </span>
                  )}
                </span>
              </div>
            </div>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer className="flex justify-end gap-1">
        <Button
          type="button"
          variant="outline"
          onClick={onClose}
          className="px-4"
        >
          Tutup
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RiasecAnswersSummary;
